/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hd--advanced-search-form-hint[_ngcontent-%COMP%]   .mat-hint[_ngcontent-%COMP%]{color:#e06666}"];
export { styles as styles };
